import React from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { TicketDetailPage } from 'page-components/auto-ticket'
import { PublicTicketShell } from 'page-components/auto-ticket/PublicTicketShell'

export const MagicTicketScreen = () => {
    const { token } = useParams()
    const [searchParams] = useSearchParams()
    const magicToken = token || searchParams.get('t') || ''

    return (
        <PublicTicketShell>
            <TicketDetailPage
                magicToken={magicToken}
                isPublic
            />
        </PublicTicketShell>
    )
}
